import csvData from "./recip-society.js";
export const data = csvData.filter((obj) => obj["ID"].length).map((entryObj) => Object.entries(entryObj).map(([key, value]) => key === "ID" ? {
  [key.toLowerCase()]: parseInt(value)
} : {
  [key.toLowerCase()]: value
}).reduce((acc, el) => ({...acc, ...el})));
